import { makeRequest } from "../../utils/makeRequest";

export async function callAccept({ trackingNumber }) {
  return makeRequest(`/accept?trackingNumber=${trackingNumber}`);
}
